import { FilterState } from 'stores/types';

export const initialState: FilterState = {
  algoliaFilter: '',
  preFilter: {},
  preFilterList: [],
  firstSearchPreFilter: {},
  specificationFilter: {},
  postFilterSelections: {},
  preFilterLoading: false,
};
